import { useState, useRef } from 'react'
import { fetchItems } from '../model/quicksearch.utils'

export const useQuickSearch = (kedo: any) => {
    const [items, setItems] = useState<any[]>([])
    const [show, setShow] = useState(false)
    const [search, setSearch] = useState('')
    const [showSearch, setShowSearch] = useState(false)
    const [loading, setLoading] = useState(false)
    const timeoutRef = useRef<NodeJS.Timeout | null>(null)

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(event.target.value)
    }

    const onKeyUp = () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current)
        timeoutRef.current = setTimeout(() => loadItems(), 200)
    }

    const loadItems = async () => {
        if (loading) return
        setLoading(true)
        setItems([])
        try {
            const data = await fetchItems(kedo, search)
            setItems(data)
            setShow(true)
        } finally {
            setLoading(false)
        }
    }

    const handleClickAway = () => {
        setShowSearch(false)
        setShow(false)
    }

    return {
        items,
        show,
        search,
        showSearch,
        loading,
        onChange,
        onKeyUp,
        setShowSearch,
        setItems,
        setSearch,
        setShow,
        handleClickAway,
    }
}